import React, { Component } from 'react'
import { compose, graphql, withApollo } from 'react-apollo'
import { Constants } from '@sukiai/components'
import {
  LO_STO,
  ROUTES,
  isEmrUser,
  isEmrConnectedUser,
  getCompFromCacheSync,
  getCompBeingCreated,
  setCompBeingCreated
} from '../../lib'
import Search from '../Search'
import loSto from '../../config/loSto'
import {
  SET_NOTE_CREATED_PENDING,
  SET_MODAL,
  GET_CURRENT_NOTETYPE_ID,
  SET_NOTE_PULL_RESPONSE,
  GET_CURRENT_COMPOSITION
} from '../../apollo/actions'
import {
  ToolBarContainer,
  ScheduleIcon,
  Container,
  NewNoteIcon,
  RefreshIcon
} from './styled'
import { withRouter } from 'react-router-dom'
import get from 'lodash/get'
import { getStreamWorker } from '../../ws/stream'
import { DataCommand } from '../../ws/DataCommand'
import { isAmwellTheme } from '../../lib/util'

const { MODALS } = Constants

// This constitutes to the icons to left of the hamburger icon
class Toolbar extends Component {
  // When schedule icon in the toolbar is clicked
  goToScheduleScreen = () => {
    this.props.history.push(ROUTES.SCHEDULE)
  }

  // When the create new note icon in the toolbar is clicked
  handleCreateNewNote = async () => {
    // TODO: When the create note fix is done this line of could will not be needed
    // TODO: until then keeping it here
    // TODO: Remove line
    loSto.remove(LO_STO.CURRENT_PATIENT_ID)
    loSto.remove(LO_STO.CURRENT_APPT_ID)
    loSto.remove(LO_STO.CURRENT_COMPOSITION)
    loSto.remove(LO_STO.CURRENT_COMP_ID)

    this.props.client.mutate({
      mutation: SET_NOTE_CREATED_PENDING,
      variables: {
        isPending: true
      }
    })

    const stream = getStreamWorker()
    stream && stream.postMessage({
      cmd: DataCommand.USER_REQUEST,
      userRequestType: 'CREATE_NOTE',
      userRequestData: {},
      ts: new Date().toISOString()
    })

    if (await getCompBeingCreated()) return
    setCompBeingCreated(true)
  }

  isRefreshNoteVisible = () => {
    if (!isEmrUser() || !isEmrConnectedUser()) {
      return false
    }

    if (window.location.pathname.split('/')[1] !== 'note') {
      return false
    }

    return true
  }

  isRefreshNoteEnabled = () => {
    const compData = getCompFromCacheSync()

    const pulledNoteFromEmr = compData?.metadata?.pulledNoteFromEmr
    if (pulledNoteFromEmr) {
      return false
    }

    const hasPatient = compData?.metadata?.patient?.id
    if (!hasPatient) {
      return false
    }

    const hasAppointment = compData?.metadata?.appointment
    if (!hasAppointment) {
      return false
    }

    return true
  }

  onRefreshNoteFromEmr = async () => {
    const { client, setModal } = this.props

    // works because button is only available on note view
    const compId = location.pathname.split('/')[2]
    const ntRes = await client.query({
      query: GET_CURRENT_NOTETYPE_ID
    })
    const currentNotetypeId = ntRes?.data?.currentNotetypeId
    const patientId = loSto.get(LO_STO.CURRENT_PATIENT_ID)
    const appointmentId = loSto.get(LO_STO.CURRENT_APPT_ID)

    const stream = getStreamWorker()
    stream && stream.postMessage({
      cmd: 'USER_REQUEST',
      userRequestType: 'CLICK_NOTES_PULL',
      userRequestData: {
        compositionId: compId,
        notetypeId: currentNotetypeId,
        patientId: patientId,
        appointmentId: appointmentId
      },
      ts: new Date().toISOString()
    })

    setModal({
      __typename: 'ModalContent',
      type: MODALS.EMR_NOTE_PULL
    })

    client.mutate({
      mutation: SET_NOTE_PULL_RESPONSE,
      variables: {
        isPending: true
      }
    })
  }

  render () {
    const { location, marginTop } = this.props
    const scheduleDisabled = get(location, 'pathname', '').includes(ROUTES.SCHEDULE)
    const newNoteDisabled = get(location, 'pathname', '').includes(ROUTES.NOTE)
    const isAmwell = isAmwellTheme()

    if (isAmwell) {
      return null
    }

    return (
      <ToolBarContainer marginTop={marginTop}>
        <Container>
          <Search data-cy='toolbar-search' />
        </Container>
        {this.isRefreshNoteVisible() &&
          <Container
            disabled={!this.isRefreshNoteEnabled()}
            onPress={this.isRefreshNoteEnabled()
              ? this.onRefreshNoteFromEmr
              : () => {}}
            data-cy='toolbar-emr-note-refresh'
          >
            <RefreshIcon data-cy='refresh-icon-btn' />
          </Container>}
        <Container
          disabled={scheduleDisabled}
          onPress={!scheduleDisabled
            ? this.goToScheduleScreen
            : () => {}}
          data-cy='toolbar-schedule'
        >
          <ScheduleIcon data-cy='schedule-icon-btn' />
        </Container>
        <Container
          disabled={newNoteDisabled}
          onPress={!newNoteDisabled
            ? this.handleCreateNewNote
            : () => {}}
        >
          <NewNoteIcon data-cy='toolbar-new-note' />
        </Container>
      </ToolBarContainer>
    )
  }
}

export default compose(
  graphql(SET_MODAL, {
    props: ({ mutate }) => ({
      setModal: content => mutate({
        variables: { content }
      })
    })
  }),
  graphql(GET_CURRENT_COMPOSITION, {
    props: ({ data: { composition } }) => ({
      compositionData: composition && JSON.parse(composition)
    })
  }),
  withRouter,
  withApollo
)(Toolbar)
